var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.5,
    height: 11.6,
    viewBox: "0 0 14.5 11.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Folder",
    d: "M16.869,9.813h-5.6L9.645,8.462A2,2,0,0,0,8.369,8H5.631A1.633,1.633,0,0,0,4,9.631v8.337A1.633,1.633,0,0,0,5.631,19.6H16.869A1.633,1.633,0,0,0,18.5,17.969V11.444A1.633,1.633,0,0,0,16.869,9.813Z",
    transform: "translate(-4 -8)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/Folder.415decfa572305baaec29a095c49203c.svg";
export { ForwardRef as ReactComponent };